import { Channel, Envs, useEnvContext } from 'scbk-services';
import { adobeAnalyticsBaseUrl } from '../constants/adobeConstants';

/**
 * 환경별 Adobe Analytics script URL
 */
const ScriptUrlMap: Record<Envs, string> = {
  //   [Envs.MOCK]: '/resource/product/adobe/adobeTest.js',
  //   [Envs.LOCAL]: '/resource/product/adobe/adobeTest.js',
  [Envs.MOCK]: '',
  [Envs.LOCAL]: '',
  [Envs.DEV]: adobeAnalyticsBaseUrl + 'launch-53e76409d585-development.min.js',
  [Envs.SIT]: adobeAnalyticsBaseUrl + 'launch-d8e4acbf3d93-staging.min.js',
  [Envs.UAT]: adobeAnalyticsBaseUrl + 'launch-d8e4acbf3d93-staging.min.js',
  [Envs.PT]: '',
  [Envs.OAT]: '',
  [Envs.STAGING]: '',
  [Envs.PROD]: adobeAnalyticsBaseUrl + 'launch-28ca2fc691d6.min.js',
};

const PlatformMap: Record<Channel, string> = {
  [Channel.IB]: 'pcWeb',
  [Channel.MB]: 'mobileApp',
  [Channel.MW]: 'mobileWeb',
};

const resolveEnv = (): Envs => {
  const { getEnv } = useEnvContext();
  const env = getEnv() as Envs | undefined;

  if (!env) return Envs.LOCAL;
  if (env in ScriptUrlMap) return env;

  return Envs.LOCAL;
};

const resolveChannel = (currentChannel?: Channel): Channel => {
  const channel = currentChannel as Channel | undefined;

  if (!channel) return Channel.MB;
  if (channel in PlatformMap) return channel;

  return Channel.MB;
};

export const getAnalyticsScriptUrl = (): string => {
  const env = resolveEnv();

  return ScriptUrlMap[env] ?? '';
};

export const getAnalyticsPlatform = (currentChannel?: Channel): string => {
  const channel = resolveChannel(currentChannel);

  return PlatformMap[channel] ?? '';
};
